import { render, staticRenderFns } from "./statisticsMonthPage.vue?vue&type=template&id=587b1a14&"
import script from "./statisticsMonthPage.vue?vue&type=script&lang=js&"
export * from "./statisticsMonthPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports